module.exports = __webpack_public_path__ + "static/media/security-audit.f24e7a42.png";